import { RIDE_STATES_QUERY } from '../../constants';
import type { RidesQueryParams } from '../types';

const CANCELED_STATES = [RIDE_STATES_QUERY.allCanceled, RIDE_STATES_QUERY.billableCanceled];

export const RIDES_FILTER_URL_KEYS = ['accountLocationIds', 'tagNames', 'serviceIds', 'sharedBillingRoles'] as const;

export const readRidesSearchQuery = (params: URLSearchParams): string =>
  params.has('query') ? params.get('query') || '' : params.get('q') || '';

export const readRidesURLState = (search: string, getEndOfDate: (date: Date) => Date) => {
  const params = new URLSearchParams(search);
  const state = params.get('state') || RIDE_STATES_QUERY.upcoming;
  const query = readRidesSearchQuery(params);
  let fromDate: string | undefined;

  if (params.has('fromDate')) {
    fromDate = params.get('fromDate') || undefined;
  } else if (CANCELED_STATES.includes(state)) {
    fromDate = getEndOfDate(new Date()).toISOString();
  }

  return { state, query, fromDate };
};

export const createRidesURLParams = (
  search: string,
  queryParams: RidesQueryParams,
  filterKeys: readonly string[] = []
): URLSearchParams => {
  const params = new URLSearchParams(search);

  params.set('state', queryParams.state);
  params.delete('query');

  if (queryParams.query) {
    params.set('q', queryParams.query);
  } else {
    params.delete('q');
  }

  if (queryParams.fromDate) {
    params.set('fromDate', queryParams.fromDate);
  } else {
    params.delete('fromDate');
  }

  filterKeys.forEach((key) => {
    const values = queryParams[key] as string[] | undefined;

    if (values?.length) {
      params.set(key, values.join(','));
    } else {
      params.delete(key);
    }
  });

  return params;
};
